export default __webpack_public_path__ + "static/media/react.a6ea03cb.png";